<template>
    <div>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Cum excepturi incidunt odit optio repellendus. Dolorem eveniet ipsa minus nobis quisquam ratione totam! Iure perferendis provident quam quis reiciendis sit vero.
    </div>
</template>

<script>
    export default {
        name: "IncidentSummary"
    }
</script>

<style scoped>

</style>
